<script> 
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import forminput from "../formcomponet/forminput.vue"; 
import satdosyaihalekomisyonu from "@/models/satdosyaihalekomisyonu";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import formcombobox from "../formcomponet/formcombobox.vue";

export default {
  mixins: [apibtoast, apigeneric, satdosyaihalekomisyonu],
  props: ["Id", "AddEdit", "satdosyaId"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader, 
    Treeselect,
    forminput,
    formcombobox

 
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Dosyaid = this.satdosyaId;
    },
  },
  methods: {
    onSubmit() {
       this.FormData.Dosyaid = this.satdosyaId;
      this.$v.$touch();
        
      if (!this.$v.$invalid) {  
     
        if (this.AddEdit == "Add") {
          this.Post("SatDosyaIhaleKomisyonu", this.FormData).then((res) => {
            if (res) {
             
                this.$emit("TableUpdate");
                 this.$bvModal.hide("satdosyaihalekomisyonu"); 
            }
          });
        } else {
          this.Update("SatDosyaIhaleKomisyonu", this.FormData).then((res) => {
            if (res) {
              
              this.$emit("TableUpdate");
              this.$bvModal.hide("satdosyaihalekomisyonu");

            }
          });
        }
      }
    },
    Get() {


    }, 
     
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="satdosyaihalekomisyonu"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('satdosyaihalekomisyonu.AddEdit.FormTitleEdit')
          : $t('satdosyaihalekomisyonu.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >  

      <Form @submit.prevent="onSubmit">   

            <forminput
              style="width:100px"
                :FormDataType="FormDataType.Sira"
                :Value="FormData.Sira"
                :v="$v.FormData.Sira"
                @input="FormData.Sira = $event"
              />
     

           <formcombobox
                  :FormDataType="FormDataType.Gorevi"
                  :Value="FormData.Gorevi"
                  :v="$v.FormData.Gorevi"
                  @input="FormData.Gorevi = $event"
            /> 


            <b-form-group class="mb-3" id="example text"  :label="FormDataType.Asilpersonelid.FieldTitle" label-for="text">
              <treeselect
              :multiple="false"
              :options="FormDataType.Asilpersonelid.ComboDataArray"
              :placeholder="$t('OrtakKullanim.seciniz')"
        
              v-model="FormData.Asilpersonelid" 
                :class="{ 'is-invalid': $v.FormData.Asilpersonelid.$error }"
              />
              <treeselect-value :value="FormData.Asilpersonelid" />
                
                  <div v-if="$v.FormData.Asilpersonelid.$error" class="invalid-feedback"> 
              <span v-if="$v.FormData.Asilpersonelid.required == false">{{  $t("ValidationMessage.required") }}</span> 
            </div>
            </b-form-group>

                  <forminput
                    :FormDataType="FormDataType.Asilunvan"
                    :Value="FormData.Asilunvan"
                    :v="$v.FormData.Asilunvan"
                    @input="FormData.Asilunvan = $event"
                  />


            <b-form-group class="mb-3" id="example text"  :label="FormDataType.Yedekpersonelid.FieldTitle" label-for="text">
              <treeselect
              :multiple="false"
              :options="FormDataType.Yedekpersonelid.ComboDataArray"
              :placeholder="$t('OrtakKullanim.seciniz')"
        
              v-model="FormData.Yedekpersonelid" 
                :class="{ 'is-invalid': $v.FormData.Yedekpersonelid.$error }"
              />
              <treeselect-value :value="FormData.Yedekpersonelid" />
                
                  <div v-if="$v.FormData.Yedekpersonelid.$error" class="invalid-feedback"> 
              <span v-if="$v.FormData.Yedekpersonelid.required == false">{{  $t("ValidationMessage.required") }}</span> 
            </div>
            </b-form-group>

                    <forminput
                    :FormDataType="FormDataType.Yedekunvan"
                    :Value="FormData.Yedekunvan"
                    :v="$v.FormData.Yedekunvan"
                    @input="FormData.Yedekunvan = $event"
                  />



 
        <button class="btn btn-primary" type="submit">
          {{ $t("satdosyaihalekomisyonu.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
